export default __webpack_public_path__ + "static/media/sumansahu.9a13946b.jpeg";